import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeader, StatusBadge } from "./shared";
import { ventures } from "../../data/portfolioData";

export const EntrepreneurshipSection = () => (
  <section id="ventures" className="py-20 lg:py-28" data-testid="entrepreneurship-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-12 lg:gap-16 items-start">
        <div className="lg:sticky lg:top-28">
          <SectionHeader
            index="05"
            eyebrow="Ventures & Products"
            title="Building Beyond Client Work."
            description="I don't only build for others. I run my own products, experiments and business concepts — learning distribution, validation and what it takes to turn software into a company."
            testId="ventures-header"
          />
          <Reveal delay={0.2}>
            <p className="font-code text-xs uppercase tracking-[0.25em] text-slate-500">
              Engineer <span className="text-amber-400">+</span> Builder <span className="text-amber-400">+</span> Entrepreneur
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 gap-5">
          {ventures.map((v, i) => (
            <Reveal key={v.name} delay={(i % 2) * 0.1}>
              <article
                className="group h-full rounded-2xl border border-white/[0.07] bg-[#0F1420] p-6 transition-all duration-500 hover:border-amber-400/20 hover:-translate-y-1"
                data-testid={`venture-card-${i}`}
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-white/[0.08] bg-gradient-to-br from-amber-400/15 to-transparent font-display text-lg font-bold text-amber-400">
                    {v.name.charAt(0)}
                  </div>
                  <StatusBadge status={v.status} />
                </div>
                <h3 className="mt-4 font-display text-lg font-semibold tracking-tight text-slate-100 flex items-center gap-1.5">
                  {v.name}
                  {v.link && (
                    <a href={v.link} target="_blank" rel="noopener noreferrer" aria-label={`${v.name} website`} data-testid={`venture-link-${i}`}>
                      <ArrowUpRight size={15} className="text-slate-500 group-hover:text-amber-400 transition-colors" />
                    </a>
                  )}
                </h3>
                <p className="mt-1 font-code text-[11px] text-slate-500">{v.role}</p>
                <p className="mt-3 text-sm text-slate-400 leading-relaxed">{v.description}</p>
                {v.technologies?.length > 0 && (
                  <div className="mt-4 flex flex-wrap gap-1.5">
                    {v.technologies.map((t) => (
                      <span key={t} className="rounded border border-white/[0.08] px-2 py-0.5 text-[10px] font-code text-slate-500">
                        {t}
                      </span>
                    ))}
                  </div>
                )}
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
